import React from 'react'
import LiteYouTube from './LiteYouTube'

const getVideoID = url => {
  const YOUTUBE_SHORT_LINK = 'youtu.be/'
  const YOUTUBE_LINK = 'youtube.com/watch?v='

  if (url.includes(YOUTUBE_SHORT_LINK)) {
    const index = url.indexOf(YOUTUBE_SHORT_LINK) + YOUTUBE_SHORT_LINK.length
    return url.slice(index, url.length)
  }
  if (url.includes(YOUTUBE_LINK)) {
    const index = url.indexOf(YOUTUBE_LINK) + YOUTUBE_LINK.length
    return url.slice(index, url.length)
  }
  return ''
}

const YouTube = ({ url, title }) => {
  // If we have a title AND the title is not the video URL
  if (title !== '' && title !== url) {
    return (
      <a target="_blank" rel="noreferrer" href={url}>
        {title}
      </a>
    )
  }

  const videoId = getVideoID(url)
  return <LiteYouTube videoId={videoId} title={url} />
}

export default YouTube
